import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';
import { ServiceFilter } from '../model/service-filter';
import { SpecialityFilter } from '../model/speciality-filter';
import { PhysicianService } from './physician.service';
import { PhysicianFilter } from '../model/physician-Filter';
import { PracticeService } from './practice.service';
import { PracticeRegionFilter } from '../model/practice-region-filter';
import { EquipmentService } from './equipment.service';
import { EquipmentFilter } from '../model/equipment-filter';
import { CenterFilter } from '../model/center-filter';
import { Entity, Plan } from '../model/entity';
import { EntityService } from './entity.service';
import { AliquotTax } from '../model/aliquot-tax';
import { MedicalOrderService } from './medical-order.service';
import { MedicalOrderScannType } from '../model/medical-order-scann-type';
import { MedicalServiceService } from './medical-service.service';
import { PatientCareTrafficLight } from '../model/patient/patient-care-traffic-light';
import { StudyReportReverseReason } from '../model/study-report-reverse-reason';
import { SectorFilter } from '../model/sector-filter';
import { InvoicePointService } from './invoice-cash-desk/invoice-point.service';
import { TaxpayerType } from '../model/taxpayer-type';
import { CreditCardFilter } from '../model/credit-card-filter';
import { BankFilter } from '../model/bank-filter';
import { DataService } from './data.service';
import { PatientService } from './patient.service';
import { SexFilter, DocumentTypeFilter } from '../model/patient';
import { GeographyService } from './geography.service';
import { CountryFilter } from '../model/geography/country-filter';
import { RelevancePatientFilter } from '../model/patient/relevance-patient-filter';
import { RelevanceReferringPhysicianFilter } from '../model/referring-physician/relevance-referring-physician-filter';
import { ReferringPhysicianSpecialityFilter } from '../model/referring-physician';
import { UserService } from './user.service';
import { Scanner } from '../model/scanner/scanner';
import { ReservationService } from './reservation.service';
import { MedicalAppointmentWaitState } from '../model/medical-appointment/medical-appointment-wait-state';
import { StudyReportService } from './study-report/study-report.service';
import { BillingOrderControlService } from './billing/billing-order-control.service';
import { BillingStateFilter } from '../model/billing/billing-state-filter';
import { AliquotTaxService } from './aliquot-tax/aliquot-tax.service';
import { NoBillingReasonFilter } from '../model/billing/no-billing-reason-filter';
import { BillingInvoicePeriod } from '../model/billing/billing-invoice-period';
import { MedicalFeeService } from './medical-fee/medical-fee.service';
import { MedicalFeeBillPeriodFilter, MedicalFeeStateFilter } from '../model/medical-fee';
import { NoMedicalFeeReasonFilter } from '../model/medical-fee/no-medical-fee-reason';
import { MedicalFeePaymentService } from './medical-fee/medical-fee-payment.service';
import { MedicalFeeWithholdTaxFilter } from '../model/medical-fee/medical-fee-with-holdTaxFilter';
import { TaxType } from '../model/tax-type';
import { VirtualWalletFilter } from '../model/virtual-wallet-filter';
import { CashDeskService } from './cash-desk.service';
import { PracticeFilter } from '../model/practice/practice-filter';


@Injectable()
export class FilterService {

  constructor(private serviceService: ServiceService
    , private physicianService: PhysicianService
    , private cashDeskService: CashDeskService
    , private entityService: EntityService
    , private medicalOrderService: MedicalOrderService
    , private practiceService: PracticeService
    , private medicalServiceService: MedicalServiceService
    , private reservationService: ReservationService
    , private studyReportService: StudyReportService
    , private invoicePointService: InvoicePointService
    , private dataService: DataService
    , private patientService: PatientService
    , private geographyService: GeographyService
    , private billingOrderControlService: BillingOrderControlService
    , private userService: UserService
    , private aliquotTaxService: AliquotTaxService
    , private medicalFeeService: MedicalFeeService
    , private medicalFeePaymentService: MedicalFeePaymentService
    , private equipmentService: EquipmentService) { }

  private readonly getBankFiltersEndPoint: string = '/invoiceCashDesk/getBankFilters/';
  private readonly getCreditCardFiltersEndPoint: string = '/invoiceCashDesk/getCreditCardFilters/';

  async getPracticesFilters(): Promise<PracticeFilter[]> {
    return await this.practiceService.getPracticesFilter();
  }

  async getMedicalFeeWithholdTaxFilters(): Promise<MedicalFeeWithholdTaxFilter[]> {
    return await this.medicalFeePaymentService.getMedicalFeeWithholdTaxFilters();
  }

  async getNoMedicalFeeReasonFilters(): Promise<NoMedicalFeeReasonFilter[]> {
    return await this.medicalFeeService.getNoMedicalFeeReasonFilters();
  }

  async getMedicalFeeStateFilters(): Promise<MedicalFeeStateFilter[]> {
    return await this.medicalFeeService.getMedicalFeeStateFilters();
  }

  async getMedicalFeeBillPeriodFilters(): Promise<MedicalFeeBillPeriodFilter[]> {
    return await this.medicalFeeService.getMedicalFeeBillPeriodFilters();
  }

  async getNoBillingReasonFilter(): Promise<NoBillingReasonFilter[]> {
    return await this.billingOrderControlService.getNoBillingReasonFilter();
  }

  async getBillingStateFilter(): Promise<BillingStateFilter[]> {
    return await this.billingOrderControlService.getBillingStateFilter();
  }

  async getMedicalAppointmentWaitStates(): Promise<MedicalAppointmentWaitState[]> {
    return await this.reservationService.getMedicalAppointmentWaitStates();
  }

  async getReferringPhysicianSpecialityFilters(): Promise<ReferringPhysicianSpecialityFilter[]> {
    return await this.physicianService.getReferringPhysicianSpecialityFilters();
  }

  async getVirtualWalletFilters(): Promise<VirtualWalletFilter[]> {
    return await this.cashDeskService.getVirtualWalletFilters();
  }

  async getScanners(): Promise<Scanner[]> {
    return await this.userService.getScanners();
  }

  async getRelevanceReferringPhysicianFilters(): Promise<RelevanceReferringPhysicianFilter[]> {
    return await this.physicianService.getRelevanceReferringPhysicianFilters();
  }

  async getRelevancePatientFilters(): Promise<RelevancePatientFilter[]> {
    return await this.patientService.getRelevancePatientFilters();
  }

  async getCountryFilters(): Promise<CountryFilter[]> {
    return await this.geographyService.getCountryFilters();
  }

  async getSexFilters(): Promise<SexFilter[]> {
    return await this.patientService.getSexFilters();
  }

  async getDocumentTypeFilters(): Promise<DocumentTypeFilter[]> {
    return await this.patientService.getDocumentTypeFilters();
  }

  async getBankFilters(): Promise<BankFilter[]> {
    const params = {};
    return await this.dataService.get<BankFilter[]>(this.getBankFiltersEndPoint, params).toPromise();
  }

  async getCreditCardFilters(): Promise<CreditCardFilter[]> {
    const params = {};
    return await this.dataService.get<CreditCardFilter[]>(this.getCreditCardFiltersEndPoint, params).toPromise();
  }

  getBillingInvoicePeriods(): BillingInvoicePeriod[] {
    const periods: BillingInvoicePeriod[] = [];
    let index = 1;

    while ( index < 13 ) {
      const period = new BillingInvoicePeriod();
      period.Id = index;
      period.Name = index.toString();
      periods.push(period);
      index += 1;
    }
    return periods;
  }

  async getTaxpayerType(): Promise<TaxpayerType[]> {
    return await this.invoicePointService.getTaxpayerType();
  }

  async getSectorsFilter(): Promise<SectorFilter[]> {
    return await this.equipmentService.getSectorsFilter();
  }

  async getStudyReportReverseReasons(): Promise<StudyReportReverseReason[]> {
    return await this.studyReportService.getStudyReportReverseReasons();
  }

  async getPatientCareTrafficLighs(): Promise<PatientCareTrafficLight[]> {
    return await this.medicalServiceService.getPatientCareTrafficLighs();
  }

  async getMedicalOrderScannTypesFilter(): Promise<MedicalOrderScannType[]> {
    return await this.medicalOrderService.getMedicalOrderScannTypes();
  }

  async getEntitiesFilter(excludeDerivantes: boolean = false): Promise<Entity[]> {
    return await this.entityService.getEntities(excludeDerivantes);
  }

  async getTaxTypes(): Promise<TaxType[]> {
    return await this.aliquotTaxService.getTaxTypes();
  }

  async getAliquotsTaxByPlanId(plaId: number): Promise<AliquotTax[]> {
    return await this.aliquotTaxService.getAliquotsTaxByPlanId(plaId);
  }

  async getAliquotsTax( taxId?: number ): Promise<AliquotTax[]> {
    const aliquots = await this.aliquotTaxService.getAliquotsTax();

    if ( taxId ) {
      return aliquots.filter( a => a.TaxId === taxId );
    }

    return aliquots;
  }

  async getPlanFilter(entityId: number): Promise<Plan[]> {
    return await this.entityService.getPlansByEntityId(entityId);
  }

  async getServicesFilter(): Promise<ServiceFilter[]> {
    return await this.serviceService.getServicesFilter();
  }

  async getSpecialtiesFilter(): Promise<SpecialityFilter[]> {
    return await this.serviceService.getSpecialtiesFilter();
  }

  async getSpecialtiesFilterOnlyConsultation(): Promise<SpecialityFilter[]> {
    return await this.serviceService.getSpecialtiesFilter(true);
  }

  async getPhysiciansFilter(practiceRegionIds: number[] = null): Promise<PhysicianFilter[]> {
    return await this.physicianService.getPhysiciansFilter(practiceRegionIds);
  }

  async getPracticesRegionFilter(): Promise<PracticeRegionFilter[]> {
    return await this.practiceService.getPracticesRegionFilter();
  }

  async getEquipmentsFilter(): Promise<EquipmentFilter[]> {
    return await this.equipmentService.getEquipmentsFilter();
  }

  async getEquipmentFilterByPhysician(physicianId: number): Promise<EquipmentFilter[]> {
    return await this.equipmentService.getEquipmentFilterByPhysician(physicianId);
  }

  async getCentersFilter(): Promise<CenterFilter[]> {
    return await this.equipmentService.getCentersFilter();
  }
}
